// extracted by mini-css-extract-plugin
export var titleSection = "projects-module--titleSection--lBTLH";
export var imgSection = "projects-module--imgSection--8PI+z";
export var imgName = "projects-module--imgName--kC0Pv";